export default __webpack_public_path__ + "static/media/hive-new.c7e2998a.svg";